import { render, staticRenderFns } from "./AddRiskViewpoints.vue?vue&type=template&id=1d1929c2&scoped=true"
import script from "./AddRiskViewpoints.vue?vue&type=script&lang=js"
export * from "./AddRiskViewpoints.vue?vue&type=script&lang=js"
import style0 from "./AddRiskViewpoints.vue?vue&type=style&index=0&id=1d1929c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1929c2",
  null
  
)

export default component.exports